<div class="overflow-x-auto w-full bg-lTable rounded-2xl">
  <table class="table">
    <thead>
      <tr>
        <ng-container *ngTemplateOutlet="header"></ng-container>
      </tr>
    </thead>

    <tbody>
      @if (!isLoading) {
        @for (item of data; track $index) {
          <tr class="hover:bg-lWhite/5">
            <ng-container *ngTemplateOutlet="body; context: { $implicit: item }"></ng-container>
          </tr>
        }
      }

      @if (isLoading) {
        @for (item of skeletons; track $index) {
          <tr class="animate-pulse">
            <td colspan="999"><div class="bg-lWhite/10 h-6 rounded"></div></td>
          </tr>
        }
      }

      @if (data.length === 0 && !isLoading) {
        <tr>
          <td colspan="999">
            <div class="flex flex-col items-center justify-center py-10">
              <img
                alt=""
                class="w-36 mb-2"
                [src]="theme() === 'dark' ? 'assets/icons/no-data-dark.svg' : 'assets/icons/no-data.svg'"
              />
              <p class="text-lSecondary">Nenhum dado disponível</p>
            </div>
          </td>
        </tr>
      }
    </tbody>

  </table>
</div>

<div class="w-full pt-10 flex items-center justify-center gap-2">
  <l-table-paginator
    [isFirstPage]="isFirstPage"
    [isLastPage]="isLastPage"
    [currentPage]="page"
    [totalPages]="totalPages"
    (firstPageClick)="firstPage()"
    (prevPageClick)="prevPage()"
    (nextPageClick)="nextPage()"
    (lastPageClick)="lastPage()"
  />
</div>
